import { Typography } from '@smartgift/frontend-toolkit';
import styled from 'styled-components';

const RECBody = styled.div`
  flex-grow: 1;
  margin-top: 24px;
`;

const RECItem = styled.div`
  background-color: var(--color-bg-weaker);
  border-radius: var(--size-border-radius-md);
  margin-top: 40px;
  padding: 24px;
`;

const RECItemBody = styled.div`
  align-items: flex-end;
  display: flex;
  gap: 24px;
`;

const RECHeader = styled.div`
  display: flex;
`;

const RECItemShare = styled.div`
  background-color: var(--color-bg-body);
  border: 1px solid var(--color-bg-stronger);
  border-radius: var(--size-border-radius-md);
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  gap: 16px;
  margin-top: 32px;
  padding: 40px;
  position: relative;
`;

const RECItemShareTitle = styled.div`
  background-color: var(--color-bg-body);
  border: 1px solid var(--color-bg-stronger);
  border-radius: var(--size-border-radius-pill);
  left: 40px;
  padding: 7px 12px;
  position: absolute;
  top: 0;
  transform: translateY(-50%);
`;

const TabDescription = styled(Typography)`
  align-items: flex-start;
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  height: 100%;
  justify-content: flex-start;
  min-width: 300px;
  width: 100%;
`;

const TabFooter = styled.div`
  background: var(--color-bg-weaker);
  border: 1px solid var(--color-border-default);
`;

const TabDescriptionText = styled(Typography)`
  align-items: center;
  background: var(--color-accent-secondary-weakest);
  border: 1px solid var(--color-accent-secondary-weaker);
  border-radius: var(--size-border-radius-md);
  color: var(--color-neutral-500);
  display: flex;
  gap: 3px;
  padding: 3px;
  width: 100%;
`;

export {
  RECBody,
  RECHeader,
  RECItem,
  RECItemBody,
  RECItemShare,
  RECItemShareTitle,
  TabDescription,
  TabDescriptionText,
  TabFooter
};
